import routerConfigFunc from 'routerConfig'

export default async function getMenuData() {
  const { menu, config } = await routerConfigFunc()
  const menuData = menu.default()
  const configData = config.default()

  return {
    menuData,
    configData,
  }
}
